function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngagedStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23.221,
    viewBox: "0 0 25 23.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61011",
    d: "M12.1 22.913a2.563 2.563 0 0 0 1.126-.474C19.852 18.17 24.1 13.166 24.1 8.1c0-4.373-3.027-7.409-6.81-7.409A5.8 5.8 0 0 0 12.1 3.94 5.753 5.753 0 0 0 6.915.691C3.12.691.1 3.727.1 8.1c0 5.066 4.254 10.07 10.87 14.338a2.563 2.563 0 0 0 1.13.475z",
    transform: "translate(.403 -.191)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagedStatus);
export default __webpack_public_path__ + "static/media/engaged_status.269d6f44.svg";
export { ForwardRef as ReactComponent };